import styled from 'styled-components'
import { Link } from 'react-router-dom';

export const ContainerMenuItem = styled(Link)`
    width: 100%;
    text-decoration: none;
`